// tslint:disable:no-input-rename
import { Directive, ElementRef, HostListener, Input, OnDestroy  } from '@angular/core';

@Directive({
    selector: '[tooltip]'
})

export class TooltipDirective implements OnDestroy {

    constructor(private elementRef: ElementRef) {}

    tooltip: any;
    elemPosition: any;
    tooltipOffset: number = 8;
    hideTimeoutId: number;
    showTimeoutId: number;

    @Input('tooltip') tooltipText = '';
    @Input() placement = 'top';
    @Input() delay = 0;
    @Input() enabled: boolean = true;
    @Input('show-delay') showDelay = 0;
    @Input('hide-delay') hideDelay = 300;
    @Input('z-index') zIndex = false;
    @Input('showin') showIn: Element;

    ngOnDestroy() {
        if (this.tooltip) {
            this.tooltip.classList.remove('tooltip-show');
            if (this.tooltip.parentNode) {
                this.tooltip.parentNode.removeChild(this.tooltip);
            }
            this.tooltip = null;
        }
    }

    @HostListener('mouseenter')
    onMouseEnter() {
        if (this.enabled) {
            this.getElemPosition();

            if (!this.tooltip) {
                this.create();
                this.setPosition();
                this.show();
            }
        }
    }

    @HostListener('mouseleave')
    onMouseLeave() {
        this.hide();
    }

    getElemPosition() {
        if (this.showIn === undefined) {
            this.elemPosition = this.elementRef.nativeElement.getBoundingClientRect();
        } else {
            this.elemPosition = this.showIn.getBoundingClientRect();
        }
    }

    create() {
        this.showDelay = this.delay || this.showDelay;
        this.tooltip = document.createElement('span');
        this.tooltip.className += 'tooltip tooltip-' + this.placement;
        this.tooltip.textContent = this.tooltipText;
        if (this.zIndex) { this.tooltip.style.zIndex = this.zIndex; }

        document.body.appendChild(this.tooltip);
    }

    show() {
        if (this.showTimeoutId) {
            clearTimeout(this.showTimeoutId);
        }

        this.showDelay = this.delay || this.showDelay;
        this.showTimeoutId = window.setTimeout(() => {
            if (this.tooltip) {
                this.tooltip.className += ' tooltip-show';
            }
        }, this.showDelay);
    }

    hide() {
        if (this.hideTimeoutId) {
            clearTimeout(this.hideTimeoutId);
        }

        if (this.tooltip) {
            this.tooltip.classList.remove('tooltip-show');
            this.hideTimeoutId = window.setTimeout(() => {
                if (this.tooltip && this.tooltip.parentNode) {
                    this.tooltip.parentNode.removeChild(this.tooltip);
                }
               this.tooltip = null;
            }, this.hideDelay);
        }
    }

    setPosition() {

        let elemHeight: number;
        let elemWidth: number;

        if (this.showIn === undefined) {
            elemHeight = this.elementRef.nativeElement.offsetHeight;
            elemWidth = this.elementRef.nativeElement.offsetWidth;
        } else {
            elemHeight = this.showIn.clientHeight;
            elemWidth = this.showIn.clientWidth;
        }

        const tooltipHeight = this.tooltip.clientHeight;
        const tooltipWidth = this.tooltip.offsetWidth;
        const scrollY = window.pageYOffset;

        if (this.placement === 'top') {
            this.tooltip.style.top = (this.elemPosition.top + scrollY) - (tooltipHeight + this.tooltipOffset) + 'px';
        }

        if (this.placement === 'bottom') {
            this.tooltip.style.top = (this.elemPosition.top + scrollY) + elemHeight + this.tooltipOffset + 'px';
        }

        if (this.placement === 'top' || this.placement === 'bottom') {
            this.tooltip.style.left = (this.elemPosition.left + elemWidth / 2) - tooltipWidth / 2 + 'px';
        }

        if (this.placement === 'left') {
            this.tooltip.style.left = this.elemPosition.left - tooltipWidth - this.tooltipOffset + 'px';
        }

        if (this.placement === 'right') {
            this.tooltip.style.left = this.elemPosition.left + elemWidth + this.tooltipOffset + 'px';
        }

        if (this.placement === 'left' || this.placement === 'right') {
            this.tooltip.style.top = (this.elemPosition.top + scrollY) + elemHeight / 2 - this.tooltip.clientHeight / 2 + 'px';
        }
    }
}
